<div class="tdo-imaging-contextmenu" [ngStyle]="{'left.px': x, 'top.px': y}" data-cy="tdo-imaging-contextmenu">
  <button mat-menu-item (click)="onContextMenuDelete('delete')" data-cy="tdo-imaging-contextmenu-delete-btn">Delete</button>
  <div *ngIf="isRuler==true" data-cy="tdo-imaging-contextmenu-ruler-container">
    <button mat-menu-item (click)="onContextMenuDelete('calibrate')" data-cy="tdo-imaging-contextmenu-calibrate-btn">Calibrate</button>
  </div>
</div>
